/** Engagement Center: admin center, notifications, notification settings, cancel dialog, sign-up. */
const engagementEN: Record<string, string> = {
  adminNavEngagement: 'Engagement Center',
  adminPurposeEngagement: 'Understand, reach and win back customers: state, messages, automations, growth, retention.',

  engCenterTitle: 'Engagement Center',
  engCenterSubtitle: 'Understand customers, reach them and bring them back before candidates are lost',
  engTab_kunden: 'Customers',
  engTab_nachrichten: 'Messages',
  engTab_vorlagen: 'Templates',
  engTab_automationen: 'Automations',
  engTab_aktionen: 'Promotions',
  engTab_wachstum: 'Growth',
  engTab_umsatz: 'Revenue',
  engTab_bindung: 'Retention',
  engTab_wirkung: 'Impact',
  engTab_einstellungen: 'Settings',

  engAll: 'All',
  engClose: 'Close',
  engSave: 'Save',
  engSearch: 'Search',
  engEmpty: 'No data yet.',
  engErrorLoad: 'Request failed',
  engErrorNotAvailable: 'This endpoint is not available yet',
  engOfTotal: 'of {{total}}',
  engMonths_one: '{{count}} month',
  engMonths_other: '{{count}} months',
  engMonthsShort: '{{value}} mo.',
  engComputedAt: 'Computed: {{at}}',

  engMetricNotConnected: 'not connected yet',
  engMetricFailed: 'calculation failed',
  engMetricPending: 'still being computed',
  engMetricNoData: 'no data',
  engMetricStatus_ok: 'up to date',
  engMetricStatus_not_connected: 'not connected yet',
  engMetricStatus_failed: 'calculation failed',
  engMetricStatus_pending: 'still being computed',

  engState_healthy: 'Healthy',
  engState_no_pilot: 'No pilot',
  engState_blocked: 'Blocked',
  engState_churn_risk: 'Churning',
  engSegment_heavy: 'Heavy',
  engSegment_normal: 'Normal',
  engSegment_occasional: 'Occasional',
  engSegment_inactive: 'Inactive',
  engRisk_stable: 'stable',
  engRisk_watch: 'watch',
  engRisk_at_risk: 'at risk',

  engOverviewStatus: 'Figures: {{status}}',
  engRollupRun: 'Run rollup now',
  engKpiActiveUsers7d: 'Active users (7 days)',
  engKpiActiveUsersSub: '{{diff}} vs. last week · of {{total}}',
  engKpiStickiness: 'Stickiness DAU/MAU',
  engKpiStickinessSub: 'B2B typical: 25–35 %',
  engKpiAutopilot: 'Autopilot running',
  engKpiAutopilotSub: 'tenants with a running campaign',
  engKpiApprovals24h: 'Approvals > 24 h',
  engKpiReplies48h: 'Replies open > 48 h',
  engTrendTitle: 'Active users per day · 28 days',
  engTrendEmpty: 'No daily values yet.',
  engTrendLegend: 'Line: active users · ▲ marker: release or message from the center',
  engStatesTitle: 'Tenant state',
  engTenantsTitle: 'Tenants',
  engTenantsEmpty: 'No tenants for this filter.',
  engFilterState: 'State',
  engFilterRisk: 'Risk',
  engColTenant: 'Tenant',
  engColUsers: 'Users',
  engColSegments: 'Segments',
  engColAutopilot: 'Autopilot',
  engColWaiting: 'Waiting for customer',
  engColState: 'State',
  engColRisk: 'Risk',
  engColLastMessage: 'Our last message',
  engCampaignsCount_one: '{{count}} campaign',
  engCampaignsCount_other: '{{count}} campaigns',
  engApprovalsCount_one: '{{count}} approval',
  engApprovalsCount_other: '{{count}} approvals',
  engRepliesCount_one: '{{count}} reply',
  engRepliesCount_other: '{{count}} replies',
  engTimelineTitle: 'Timeline · {{name}}',
  engTimelineEmpty: 'No events in the last 30 days.',
  engTimelineKind_user: 'User action',
  engTimelineKind_autopilot: 'Autopilot',
  engTimelineKind_message: 'Message from us',
  engTimelineKind_incident: 'Incident',

  engComposeTitle: 'Compose message',
  engComposeModeTemplate: 'With template',
  engComposeModeFree: 'Free text',
  engComposeTemplate: 'Template',
  engComposeTitleField: 'Title',
  engComposeBody: 'Text',
  engComposeCtaLabel: 'Button label',
  engComposeCtaUrl: 'Button target (path in PAI)',
  engComposeTopicClass: 'Class',
  engComposeTopic: 'Occasion',
  engComposeTopicHelp: 'Shown in the history; empty = template name or title',
  engComposeChannels: 'Channels',
  engComposeAudience: 'Audience',
  engComposeDelivery: 'Delivery',
  engComposeDeliveryWindow: 'Next delivery window, 9:30',
  engComposeDeliveryImmediate: 'Immediately',
  engComposePreview: 'Refresh preview',
  engComposeTest: 'Test to me',
  engComposeTestAgain: 'Send test again',
  engComposeTesting: 'Sending test …',
  engComposeTestOk: 'Test sent. Sending is unlocked as long as the content does not change.',
  engComposeSend_one: 'Send to {{count}} user',
  engComposeSend_other: 'Send to {{count}} users',
  engComposeRequestApproval_one: 'Submit for approval ({{count}} user)',
  engComposeRequestApproval_other: 'Submit for approval ({{count}} users)',
  engComposeHintNeedsTest: 'Sending unlocks after the test (required above {{limit}} recipients). Any change to the content needs a new test.',
  engComposeBlocker_no_content: 'Pick a template or enter title and text first.',
  engComposeBlocker_no_channel: 'Pick at least one channel.',
  engComposeBlocker_no_estimate: 'Audience is still being estimated.',
  engComposeBlocker_no_recipients: 'The audience is empty.',
  engComposeBlocker_needs_test: 'Send "Test to me" first.',
  engComposeApprovalHint: 'To everyone or more than 500 recipients: a second admin must approve.',
  engComposeError409: 'The API requires a test with exactly this content first.',
  engComposeErrorGeneric: 'That did not work',
  engEstimateLoading: 'Estimating audience …',
  engEstimateFailed: 'Estimate failed. Sending stays locked without an estimate.',
  engEstimateText: 'Estimate: {{targeted}} users · {{withEmail}} with e-mail',
  engEstimateExcluded_one: '{{count}} excluded ({{reason}})',
  engEstimateExcluded_other: '{{count}} excluded ({{reason}})',
  engSendResult_scheduled: 'Scheduled.',
  engSendResult_running: 'Sending.',
  engSendResult_completed: 'Sent.',
  engSendResult_completed_disabled: 'Recorded but not delivered: sending to customers is switched off. The outbox lists it as skipped.',
  engSendResult_failed: 'Failed.',
  engSendResult_awaiting_approval: 'Submitted: a second admin must approve.',
  engSendResult_dry_run: 'Dry run, nothing sent.',
  engPreviewTitle: 'Preview',
  engPreviewEmpty: 'No preview yet. "Refresh preview" renders every selected channel.',
  engPreviewFor: 'Preview for {{user}}',
  engPreviewMissing: 'Missing variables: {{vars}}',
  engPreviewEmailSubject: 'E-mail · subject',
  engPreviewVarsNote: 'Fixed variables come from the database, not from the AI. The AI only phrases the sentence around them.',
  engAudienceKind: 'Recipients',
  engAudienceKind_all: 'All users',
  engAudienceKind_tenants: 'Tenants',
  engAudienceKind_users: 'Individual users',
  engAudienceKind_state: 'By state',
  engAudienceKind_segment: 'By segment',
  engAudienceKind_trial: 'Trial customers',
  engAudienceTenants: 'Pick tenants',
  engAudienceUserIds: 'User IDs',
  engAudienceUserIdsHelp: 'Separated by comma or space',
  engAudienceTrialFrom: 'from trial day',
  engAudienceTrialTo: 'to trial day',
  engAudienceMinReplies: 'min. replies',
  engAudienceRequireConsent: 'Only with marketing consent (required for offers by e-mail)',
  engChannel_notification: 'Notification in PAI',
  engChannel_email: 'E-mail',
  engChannel_banner: 'Banner at login',
  engTopicClass_transactional: 'Transactional',
  engTopicClass_product: 'Product',
  engTopicClass_offer: 'Offer',
  engTopicClass_news: 'News',
  engOutboxTitle: 'Sent messages',
  engOutboxEmpty: 'No messages sent yet.',
  engOutboxSource: 'Origin',
  engOutboxSource_all: 'All (without tests)',
  engOutboxSource_automation: 'Automation',
  engOutboxSource_system: 'System (account mails, daily report …)',
  engOutboxSource_manual: 'Admin',
  engOutboxSource_test: 'Tests',
  engColDate: 'Date',
  engColTopic: 'Occasion',
  engColFrom: 'From',
  engColChannels: 'Channels',
  engColChannel: 'Channel',
  engColTargeted: 'targeted',
  engColDelivered: 'delivered',
  engColOpened: 'opened',
  engColReturned: 'returned',
  engColCompleted: 'done',
  engColSkipped: 'skipped',
  engColStatus: 'Status',
  engColRecipient: 'Recipient',
  engColSentAt: 'sent',
  engSourceAutomation: 'Automation {{key}}',
  engSourceSystem: 'System',
  engSourceViaUi: '{{name}} in the UI',
  engSourceViaMcp: '{{name}} via MCP',
  engSourceType_manual: 'manual',
  engSourceType_test: 'Test',
  engStatus_scheduled: 'scheduled',
  engStatus_running: 'running',
  engStatus_completed: 'completed',
  engStatus_failed: 'failed',
  engStatus_awaiting_approval: 'awaiting approval',
  engStatus_dry_run: 'dry run',
  engApprove: 'Approve',
  engApproveOwnHint: 'Approval must come from an admin other than the requester.',
  engMessageDetail: 'Message',
  engArtifacts: 'Evidence (the e-mail as it went out)',
  engKillSwitch: 'Kill switch triggered on {{at}}: {{reason}}',
  engKillSwitchShort: 'Kill switch',
  engSkip_skipped_disabled: 'sending switched off',
  engSkip_disabled: 'sending switched off',
  engSkip_skipped_preference: 'opted out',
  engSkip_preference: 'opted out',
  engSkip_skipped_capped: 'budget reached',
  engSkip_capped: 'budget reached',
  engSkip_skipped_cooldown: '48 h cooldown',
  engSkip_cooldown: '48 h cooldown',
  engSkip_skipped_sunset: 'no longer responds',
  engSkip_sunset: 'no longer responds',
  engSkip_skipped_read: 'already read',
  engSkip_read: 'already read',
  engSkip_skipped_resolved: 'occasion resolved',
  engSkip_resolved: 'occasion resolved',
  engSkip_skipped_suppressed: 'address suppressed',
  engSkip_suppressed: 'address suppressed',
  engSkip_skipped_no_consent: 'no consent',
  engSkip_no_consent: 'no consent',
  engSkip_skipped_control: 'control group',
  engSkip_control: 'control group',
  engSkip_no_email: 'no e-mail',
  engDeliveryStatus_pending_window: 'waiting for delivery window',
  engDeliveryStatus_sent: 'sent',
  engDeliveryStatus_failed: 'failed',
  engDeliveryStatus_bounced: 'bounced',
  engDeliveryStatus_skipped_disabled: 'skipped: sending off',
  engDeliveryStatus_skipped_preference: 'skipped: opted out',
  engDeliveryStatus_skipped_capped: 'skipped: budget',
  engDeliveryStatus_skipped_cooldown: 'skipped: cooldown',
  engDeliveryStatus_skipped_sunset: 'skipped: unresponsive',
  engDeliveryStatus_skipped_read: 'skipped: read',
  engDeliveryStatus_skipped_resolved: 'skipped: resolved',
  engDeliveryStatus_skipped_suppressed: 'skipped: suppressed',
  engDeliveryStatus_skipped_no_consent: 'skipped: no consent',
  engDeliveryStatus_skipped_control: 'skipped: control group',
  engBannerSendOff: 'Sending to customers is switched off (ENGAGEMENT_SEND_ENABLED). Only tests to platform admins are delivered; everything else is logged as "skipped: sending off".',
  engBannerAutomationsOff: 'Automations do not send (ENGAGEMENT_AUTOMATIONS_ENABLED off). They compute their audience and only log what they would send.',
  engBannerDerived: '(derived from the API figures)',

  engTemplatesTitle: 'Templates',
  engTemplatesEmpty: 'No templates yet.',
  engTemplateNew: 'New template',
  engTemplatePick: 'Pick a template on the left or create one.',
  engTemplateEditTitle: '{{name}} · {{lang}} · {{channel}}',
  engTemplateKey: 'Key',
  engTemplateName: 'Name',
  engTemplateActive: 'active',
  engTemplateActivateNeedsTest: 'Activation requires a test first.',
  engTemplateTitle: 'Title',
  engTemplateSubject: 'Subject',
  engTemplateBody: 'Text',
  engTemplateBenefit: 'Benefit for the recipient (required)',
  engTemplateBenefitHelp: 'One sentence: what does the customer gain from this message?',
  engTemplateVariables: 'Variables',
  engTemplateAddVariable: 'Variable',
  engTemplateVarName: 'Variable',
  engTemplateVarSource: 'Source',
  engTemplateVarDetail: 'Path / instruction',
  engTemplateVarsNote: 'Fixed = from the database. AI only phrases, never invents. Manual = filled in when sending.',
  engVarSource_deterministic: 'fixed',
  engVarSource_manual: 'manual',
  engVarSource_llm: 'AI',
  engVarLlmPlaceholder: 'e.g. a friendly sentence inviting a reply',
  engVarManualHint: 'filled in when composing',
  engTemplateSystem: 'System',
  engTemplateStatus_active: 'active',
  engTemplateStatus_inactive: 'inactive',
  engTemplateStatus_untested: 'test missing',
  engTemplateSaved: 'Template saved.',
  engTemplateTestSent: 'Test sent to you.',
  engTemplateLastTested: 'Last tested: {{at}}',
  engTemplateNeverTested: 'Never tested',

  engAutomationsTitle: 'Automations',
  engAutomationsIntro: 'Each automation is trigger + condition + template. At most one occasion runs per user at a time; list order is priority.',
  engAutomationsEmpty: 'No automations set up.',
  engColAutomation: 'Occasion',
  engColTrigger: 'Trigger',
  engColLastRun: 'Last run',
  engColEvaluated: 'evaluated',
  engColSent: 'sent',
  engColWouldSend: 'would send',
  engColEnabled: 'on',
  engWouldSendValue_one: 'would send {{count}}',
  engWouldSendValue_other: 'would send {{count}}',
  engNeverRun: 'never',
  engDryRun: 'Dry run',
  engDryRunTitle: 'Dry run {{key}}',
  engDryRunCount_one: '{{count}} recipient would get the message.',
  engDryRunCount_other: '{{count}} recipients would get the message.',
  engDryRunNote: 'Nothing was sent.',

  engPromoNew: 'New promotion',
  engPromoName: 'Name',
  engPromoDiscount: 'Discount',
  engPromoDiscountLabel: '{{percent}} % for {{months}} months',
  engPromoCustom: 'Custom values',
  engPromoPercent: 'Discount in %',
  engPromoMonths: 'Months',
  engPromoAudience: 'Who gets it',
  engPromoEndsAfter: 'Valid (days after delivery)',
  engPromoEndsAfterHelp: 'Real deadline, never extended',
  engPromoMaxRedemptions: 'max. redemptions',
  engPromoControl: 'Control group in %',
  engPromoControlHelp: 'deliberately get no discount',
  engPromoStripeNote: 'The Stripe coupon is created on confirmation: once per tenant, new customers only, expiry set.',
  engPromoPreview: 'Preview',
  engPromoConfirm: 'Confirm and create',
  engPromoPreviewTitle: 'Preview',
  engPromoPreviewNothingCreated: 'Nothing created yet.',
  engPromoPreviewStale: 'Changed since the preview: please preview again.',
  engPromoControlSize_one: 'Control group: {{count}} recipient',
  engPromoControlSize_other: 'Control group: {{count}} recipients',
  engPromoCreated: 'Promotion created.',
  engPromoList: 'Running and past promotions',
  engPromoEmpty: 'No promotions yet.',
  engPromoRedeemed: 'redeemed',
  engPromoRevenue: 'Revenue',
  engPromoEnd: 'End',
  engPromoCap_one: 'max. {{count}} redemption',
  engPromoCap_other: 'max. {{count}} redemptions',
  engPromoStatus_draft: 'draft',
  engPromoStatus_running: 'running',
  engPromoStatus_ended: 'ended',
  engPromoControlRow: 'Without promotion (comparison)',
  engPromoControlGroup: 'Control group',
  engPromoControlNote: 'Some recipients deliberately get no discount. Only then can you see whether the discount brings purchases or just costs revenue that would have come anyway.',

  engKpiRegistrations: 'Registrations (30 d)',
  engKpiActivated: 'Activated',
  engKpiActivatedSub: 'LinkedIn connected + campaign',
  engKpiFirstReply: 'Saw a first reply',
  engKpiFirstReplySub: 'of registrations',
  engKpiTrialToPurchase: 'Trial → purchase',
  engKpiPurchasesCount_one: '{{count}} purchase',
  engKpiPurchasesCount_other: '{{count}} purchases',
  engKpiCostPerCustomer: 'Cost per customer',
  engKpiCostPerCustomerSub: 'ads + dedicated IPs of trial accounts',
  engFunnelTitle: 'Channels up to purchase',
  engFunnelEmpty: 'No registrations in this period yet.',
  engColSource: 'Channel',
  engColSpend: 'Spend',
  engColRegistrations: 'Registr.',
  engColActivated: 'activated',
  engColFirstReply: '1st reply',
  engColPurchases: 'Purchases',
  engColCostPerCustomer: '€ / customer',
  engSourceDirect: 'No ad (direct, referral)',
  engSourceUnattributed: 'unattributed',
  engControlSumOk: 'Check passed: channels + no ad + unattributed = Stripe revenue.',
  engControlSumNotOk: 'Check failed: the sum differs from Stripe revenue; the figures are not reliable.',
  engTrialFunnelTitle: 'Trial month · where the {{count}} registrations stand',
  engTrialPipeline: 'Trial customers',
  engTrialEmpty: 'No trial customers for this filter.',
  engColTrialDay: 'Day',
  engColReplies: 'Replies',
  engColConsent: 'Marketing consent',
  engExperimentsTitle: 'Website tests',
  engExperimentsEmpty: 'No running tests.',
  engColExperiment: 'Test · variant',
  engColViews: 'Views',
  engColCtaRate: 'Click "Register"',
  engColDecision: 'Status',
  engExpUndecided: 'not decidable yet',
  engExpProgress: 'day {{day}} · {{share}} of required visitors',
  engExpWinner: '{{variant}} wins · {{probability}} probability',
  engExpLoser: 'loses',
  engExpNote: 'Judged up to purchase. Until there are enough visitors the center shows "not decidable yet" instead of an early winner.',

  engKpiAdSpend: 'Ad spend (30 d)',
  engKpiAdSpendSub: 'Google + Meta',
  engKpiRevenueFromAds: 'Revenue from it so far',
  engKpiRoasTarget: 'Target after 12 months: ≥ 4',
  engRoasTitle: 'Ad campaigns',
  engRoasEmpty: 'No ad campaigns yet.',
  engRoasNote: 'ROAS = revenue ÷ ad spend. Customers without an origin appear as "unattributed" and are not assigned to any channel.',
  engColAdCampaign: 'Ad campaign',
  engColRevenueToDate: 'Revenue to date',
  engColRoasToDate: 'ROAS to date',
  engColRoas12m: 'ROAS 12 m',
  engColPayback: 'Payback',

  engKpiPaying: 'Paying tenants',
  engKpiMrr: 'Monthly revenue',
  engKpiMrrSub: 'recurring',
  engKpiChurn: 'Churn rate',
  engKpiNrr: 'Net revenue retention',
  engKpiAtRisk: 'At risk',
  engKpiAtRiskSub: '{{mrr}} monthly',
  engAtRiskTitle: 'Paying customers at risk',
  engAtRiskEmpty: 'No paying customer at risk.',
  engColMrr: '€ / month',
  engColReasons: 'Reasons',
  engCohortsTitle: 'Share still paying by start month',
  engCohortsEmpty: 'No cohorts yet.',
  engCohortsNote: 'Each row is a start month, each column a month after. Empty cells lie in the future.',
  engReactivationTitle: 'Reactivation · former customers',
  engReactivation_formerTenants: 'Former customers',
  engReactivation_formerContacted: 'contacted (win-back ladder)',
  engReactivation_reactivated: 'returned',
  engReactivation_cancelIntents: 'cancellation intents (12 months)',
  engReactivation_paused: 'paused instead of cancelled',
  engReactivation_downgraded: 'smaller plan instead of cancelled',
  engReactivation_reviewRequested: 'campaign review requested',
  engReactivation_kept: 'stayed',
  engReactivation_cancelled: 'cancelled',
  engChurnReasonsTitle: 'Cancellation reasons',
  engChurnReasonsEmpty: 'No cancellation reasons recorded yet.',

  engKpiUnsubscribeRate: 'E-mail unsubscribe rate',
  engKpiLowTouch: 'Low-touch users',
  engKpiLowTouchSub: 'only notifications and account mails',
  engKpiKillSwitch: 'Kill switch triggered',
  engInsightsFunnel: 'Funnel · all messages, 30 days',
  engInsightsCompletedNote: '"Done" means the occasion is gone: approval given, reply written or account unlocked. This is the figure that counts, not the open rate.',
  engInsightsHistogram: 'Non-transactional messages per user and week',
  engInsightsSkips: 'Skipped by reason',
  engFunnelStep_targeted: 'targeted',
  engFunnelStep_sent: 'sent',
  engFunnelStep_delivered: 'delivered',
  engFunnelStep_opened: 'opened',
  engFunnelStep_clicked: 'clicked',
  engFunnelStep_returned: 'returned',
  engFunnelStep_completed: 'done',

  engSettingsSwitches: 'Switches',
  engSwitchSend: 'Sending to customers',
  engSwitchAutomations: 'Automations send',
  engSwitchOn: 'on',
  engSwitchOff: 'off',
  engSwitchUnknown: 'unknown',
  engSettingsSwitchesNote: 'The switches live in the API environment (ENGAGEMENT_SEND_ENABLED, ENGAGEMENT_AUTOMATIONS_ENABLED) and cannot be flipped here.',
  engSettingsTimeSaved: 'Time saved per action (minutes)',
  engSettingsTimeSavedNote: 'These values are shown openly in every results summary. Better to calculate conservatively.',
  engTimeProfileReview: 'Profile review',
  engTimeConnectionRequest: 'Personal request',
  engTimeFollowUp: 'Follow-up message',
  engTimeInmail: 'InMail',
  engSettingsCaps: 'Sending discipline',
  engSettingsCapsNote: 'Applies to every sending path. Account mails are exempt from the budget.',
  engCapEmailPerDay: 'E-mails per day',
  engCapEmailPerWeek: 'E-mails per week',
  engCapNotificationPerDay: 'Notifications per day',
  engCapCooldownHours: 'Gap between occasions (h)',
  engSunsetAfter: 'less contact after unopened messages',
  engSettingsSaved: 'Saved.',

  engNotifTitle: 'Notifications',
  engNotifAriaUnread_one: 'Notifications, {{count}} unread',
  engNotifAriaUnread_other: 'Notifications, {{count}} unread',
  engNotifReadAll: 'Mark all read',
  engNotifMarkRead: 'Mark read',
  engNotifEmpty: 'No notifications.',
  engNotifLoadFailed: 'Notifications could not be loaded.',
  engNotifShowAll: 'All notifications',
  engNotifPageSubtitle: 'Notes from PAI about your campaigns, your account and news.',
  engNotifSettingsLink: 'Notification settings',

  engPrefsTab: 'Notifications',
  engPrefsSubtitle: 'What you receive as a notification in PAI and by e-mail',
  engPrefsIntro: 'Choose per type and channel what you receive.',
  engPrefsFootnote: 'Account and security cannot be switched off. Offers by e-mail only with your consent. Changes apply when you save.',
  engPrefsSaved: 'Saved.',
  engPrefsSaveFailed: 'Saving failed.',
  engPrefTopic_account: 'Account and security',
  engPrefTopicHint_account: '2FA, captcha, license',
  engPrefTopic_campaigns: 'Campaigns',
  engPrefTopicHint_campaigns: 'replies, approvals, ran empty',
  engPrefTopic_daily_report: 'Daily report',
  engPrefTopicHint_daily_report: 'summary of the day',
  engPrefTopic_news: 'News',
  engPrefTopicHint_news: 'new features, tips',
  engPrefTopic_offers: 'Offers',
  engPrefTopicHint_offers: 'discounts and promotions',
  engPrefAccountLocked: 'Cannot be switched off',
  engPrefOffersNeedConsent: 'Only with consent to offers by e-mail',
  engConsentsTitle: 'Consents',
  engConsentsIntro: 'Both are voluntary and can be withdrawn at any time. A withdrawal applies immediately.',
  engConsentMarketing: 'Receive offers and tips by e-mail',
  engConsentAdMeasurement:
    'Measure ad success and relevant ads: we may tell Google and Meta when you signed up, set up your account or subscribed via an ad (with the click ID, for Meta also your e-mail address in hashed form). Both may then show relevant ads from us to you and to similar people.',
  engConsentSince: 'given on {{at}}',
  engConsentWithdrawnAt: 'withdrawn on {{at}}',
  engConsentSaveFailed: 'Consent could not be saved.',
  engConsentsLoadFailed: 'Consents could not be loaded.',

  engCancelButton: 'Cancel subscription',
  engCancelTitle: 'Your time with SAIA',
  engCancelTitleMonths_one: 'Your {{count}} month with SAIA',
  engCancelTitleMonths_other: 'Your {{count}} months with SAIA',
  engCancelResultsFailed: 'Your results could not be loaded right now. You can still cancel.',
  engResultConversations: 'Conversations',
  engResultReplies: 'Replies',
  engResultHoursSaved: 'saved',
  engCancelWhy: 'Why do you want to cancel?',
  engCancelReason_role_filled: 'Position is filled',
  engCancelReason_too_expensive: 'Too expensive',
  engCancelReason_no_results: 'Too few results',
  engCancelReason_other: 'Other reason',
  engCancelComment: 'What was missing? (optional)',
  engCancelPauseMonths: 'Pause for',
  engCancelPauseButton_one: 'Pause {{count}} month',
  engCancelPauseButton_other: 'Pause {{count}} months',
  engCancelDowngradeButton: 'See a smaller plan',
  engCancelReviewButton: 'Campaign check with SAIA',
  engCancelPaused_one: 'Paused for {{count}} month. Nothing is charged; contacts and campaigns are kept.',
  engCancelPaused_other: 'Paused for {{count}} months. Nothing is charged; contacts and campaigns are kept.',
  engCancelPauseFailed: 'Pausing did not work. Please try again later.',

  engSignupConsentMarketing: 'I would like to receive offers and tips by e-mail (can be withdrawn at any time)',
  engSignupConsentAdMeasurement:
    'Measure ad success and relevant ads: Google and Meta may learn whether I signed up, set up my account or subscribed via an ad (with the click ID, for Meta also my e-mail address in hashed form), and show relevant ads to me and to similar people. Can be withdrawn at any time, details in the privacy policy.',
  engAtRiskPartial: 'Customer health {{status}}: only cancellations and open payments are considered.',
  engDryRunStatus_would_send: 'would send',
  engDryRunStatus_sent: 'sent',
  engDryRunStatus_already_sent: 'already received',
  engDryRunStatus_lower_priority: 'another automation has priority',
  engDryRunStatus_control_group: 'control group',
  engDryRunStatus_failed: 'failed',
  engTrialStage_registered: 'registered',
  engTrialStage_trial: 'in trial',
  engTrialStage_activated: 'activated',
  engTrialStage_first_reply: 'first reply',
  engTrialStage_trial_expired: 'trial expired',
  engSkip_missing_variable: 'variable without value',
  engSkip_skipped_missing_variable: 'variable without value',
  engSkip_inactive_user: 'user inactive',
  engSkip_min_replies: 'too few replies',
  engSkip_results_not_connected: 'results not connected',
  engSkip_results_failed: 'results could not be computed',
  engDeliveryStatus_skipped_missing_variable: 'skipped: variable without value',
  engStatus_rejected: 'rejected',
  engSendResult_rejected: 'Rejected.',
};

export default engagementEN;
